<template>
  <div v-if="hasActions" class="space-y-12" data-test="mobile-plan-actions">
    <MobilePlanAction
      v-for="(action, index) in validActions"
      :key="action.type"
      :mobile-plan-action="action"
      :orderline-id
      :variant="getVariant(index)"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { isEmpty } from '@backmarket/utils/object/isEmpty'

import { ORDERLINE_BUNDLED_MOBILE_PLAN_ACTIONS } from '~/api/my-orders/types/OrderlineBundledMobilePlan.types'

import type { MobilePlanActionsProps } from './MobilePlanActions.types'
import MobilePlanAction from './components/MobilePlanAction.vue'

const props = withDefaults(defineProps<MobilePlanActionsProps>(), {
  onlySecondaryCta: false,
})

const hasActions = !isEmpty(props.mobilePlanActions)

const validActions = computed(() =>
  props.mobilePlanActions.filter((action) =>
    Object.values(ORDERLINE_BUNDLED_MOBILE_PLAN_ACTIONS).includes(action.type),
  ),
)

const getVariant = (index: number) => {
  if (props.onlySecondaryCta) {
    return 'secondary'
  }

  return index === 0 ? 'primary' : 'secondary'
}
</script>
